import queryString from 'qs';
import { CookieService } from './cookie-service';

let gitSha = '';
let sourceType = '';

const GIT_SHA_COOKIE_NAME = 'prBuildGitSha';
const SOURCE_TYPE_COOKIE_NAME = 'prBuildSourceType';

export const initPrBuildService = () => {
  const query = queryString.parse(window.location.search.substr(1));
  if ((query.gitSha && query.sourceType) || query?.sourceType === 'local') {
    CookieService.setCookieValueWithPathAndDomain(GIT_SHA_COOKIE_NAME, query.gitSha);
    CookieService.setCookieValueWithPathAndDomain(SOURCE_TYPE_COOKIE_NAME, query.sourceType);
  }

  gitSha = CookieService.getCookieValue(GIT_SHA_COOKIE_NAME);
  sourceType = CookieService.getCookieValue(SOURCE_TYPE_COOKIE_NAME);
};

export const isPrBuild = () => sourceType === 'local' || (!!gitSha && !!sourceType);

export const getPrBuildData = () => ({ gitSha, sourceType });

export const clearCookie = () => {
  CookieService.removeCookie(GIT_SHA_COOKIE_NAME);
  CookieService.removeCookie(SOURCE_TYPE_COOKIE_NAME);
};
